const addrouters = {
  state: {
    roles: [1]
  },
  mutations: {
    SET_ROLES (state, val) {
      state.roles = val
    }
  }
}

export default addrouters



// WEBPACK FOOTER //
// ./src/store/modules/addrouters.js